import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  CreditControlDevelopmentSummaryModel,
  CreditControlStatusModel,
  CreditControlUnitModel,
  ICPLClientPortalCreditControlClient,
} from "./api/cplapi/CPLAPI";

export interface IClientPortalCreditControlService {
  getCreditControlDevelopmentSummaries(): Promise<CreditControlDevelopmentSummaryModel[]>;
  getCreditControlStatusSummaries(developmentID: string): Promise<CreditControlStatusModel>;
  getCreditControlUnitBreakdown(developmentID: string, statusID: number): Promise<CreditControlUnitModel>;
}

@injectable()
export class ClientPortalCreditControlService implements IClientPortalCreditControlService {
  @inject(SERVICE_TYPES.CPLClientPortalCreditControlClient)
  cplClientPortaCreditControlClient!: ICPLClientPortalCreditControlClient;

  async getCreditControlDevelopmentSummaries(): Promise<CreditControlDevelopmentSummaryModel[]> {
    return await this.cplClientPortaCreditControlClient.getCreditControlDevelopmentSummaries();
  }

  async getCreditControlStatusSummaries(developmentID: string): Promise<CreditControlStatusModel> {
    return await this.cplClientPortaCreditControlClient.getCreditControlStatusSummaries(developmentID);
  }

  async getCreditControlUnitBreakdown(developmentID: string, statusID: number): Promise<CreditControlUnitModel> {
    return await this.cplClientPortaCreditControlClient.getCreditControlUnitBreakdown(developmentID, statusID);
  }
}
